import ICON_ARROW_RIGHT from '../../assets/images/icon_arrow_right_white.svg';
import ICON_COMPARE from '../../assets/images/icon_compare.png';
import ICON_DELIVERY from '../../assets/images/icon_delivery_green.png';

import ICON_ORDER from '../../assets/images/icon_order.png';
import ICON_PAYMENT from '../../assets/images/icon_payment.png';

import IMG_COMPAREPRICE from '../../assets/images/image_buy_compare.png';
import IMG_SAVETIME from '../../assets/images/image_buy_savetime.png';
import IMG_FINDPRODUCT from '../../assets/images/image_buy_search.png';

import PropTypes from 'prop-types';
import './LandingBuyContent.css';

const LandingBuyContent = (props) => {
  const renderButton = (text, icon) => {
    return (
      <button
        onClick={() => {
          if (props.callback_popup_signin) {
            props.callback_popup_signin();
          }
        }}
        className='button-primary'
      >
        <div className='button-content'>
          <div className='button-text'>{text}</div>
          <img className='button-icon' alt='' src={icon} />
        </div>
      </button>
    );
  };

  const renderIntroSection = () => {
    return (
      <div className='intro-section'>
        <b className='intro-title'>การซื้อสินค้าผ่านมียา.com</b>
        <div className='intro-description'>
          <p className='intro-paragraph'>&quot;เราต้องการสร้างพื้นที่ปลอดภัยสำหรับผู้ประกอบการ</p>
          <p className='intro-paragraph'>ในการจัดหาสินค้ามาจำหน่ายในร้าน รวมถึงทางเลือก</p>
          <p className='intro-paragraph'>ในการค้นหาสินค้าที่มีความหลากหลายทางราคา</p>
          <p className='intro-paragraph-last'>และความแปลกใหม่&quot;</p>
        </div>
        {renderButton('ซื้อสินค้า', ICON_ARROW_RIGHT)}
      </div>
    );
  };

  const renderProcessStep = (title, description, icon, link) => {
    const content = (
      <>
        <div className='step-icon-wrapper'>
          <img src={icon} alt={title} className='process-step-icon' />
        </div>
        <b className='process-title'>{title}</b>
        <div className='process-description'>{description}</div>
      </>
    );

    if (link) {
      return (
        <a href={link} target='_blank' rel='noopener noreferrer' className='process-step-card'>
          {content}
        </a>
      );
    }

    return <div className='process-step-card'>{content}</div>;
  };

  const renderBuyProcessSection = () => {
    return (
      <div className='buy-process-section'>
        <div className='process-steps'>
          {renderProcessStep(
            'COMPARE',
            'เปรียบเทียบราคาสินค้าจากแต่ละร้านค้า',
            ICON_COMPARE,
            'https://www.youtube.com/watch?v=WuuSfEI1ovU&index=4&t=27s',
          )}
          {renderProcessStep(
            'ORDER',
            'สั่งซื้อสินค้าจากร้านค้าที่ดีที่สุด',
            ICON_ORDER,
            'https://www.youtube.com/watch?v=WuuSfEI1ovU&index=4&t=8s',
          )}
          {renderProcessStep('MAKE PAYMENT', 'ชำระเงินค่าสินค้า', ICON_PAYMENT)}
          {renderProcessStep(
            'DELIVERY',
            'รอสินค้าที่จะจัดส่งไปให้คุณจากทั่วประเทศ',
            ICON_DELIVERY,
            'https://www.youtube.com/watch?v=CsLNpDvaD6c&index=2&t=40s',
          )}
        </div>
      </div>
    );
  };

  const renderBenefitCard = (image, title, subtitle) => {
    const isComparePrice = image === IMG_COMPAREPRICE;

    return (
      <div className='benefit-card'>
        <div className='benefit-image-container'>
          <img
            className={`benefit-image ${isComparePrice ? 'compare-price-image' : ''}`}
            alt=''
            src={image}
          />
        </div>
        <div className='benefit-text'>
          <p className={`benefit-title ${!subtitle ? 'no-subtitle' : ''}`}>{title}</p>
          {subtitle && <p className='benefit-subtitle'>{subtitle}</p>}
        </div>
      </div>
    );
  };

  return (
    <div className='landing-buy-container' id='landing-buy-section'>
      <div className='landing-content'>
        <div className='landing-sections'>
          {renderIntroSection()}
          {renderBuyProcessSection()}
        </div>
        <div className='benefit-cards'>
          {renderBenefitCard(IMG_SAVETIME, 'ประหยัดเวลา', '')}
          {renderBenefitCard(IMG_FINDPRODUCT, 'ค้นหาสินค้าได้รวดเร็ว', 'และหลากหลาย')}
          {renderBenefitCard(IMG_COMPAREPRICE, 'เปรียบเทียบราคา', 'ได้ในที่เดียว')}
        </div>
      </div>
      <div className='divider-container'>
        <div className='divider' />
      </div>
    </div>
  );
};

LandingBuyContent.propTypes = {
  callback_popup_signin: PropTypes.func,
};

export default LandingBuyContent;
